module.exports = __webpack_public_path__ + "media/images/logo-evs-text-white-fb793751afe8f34ce8b932efcb7cb92d.svg";